import { Controller } from "@hotwired/stimulus"
import { isDirty, onDirtyChange, flushAll } from "plan_storage"

// Per-goal Save button. The plan already auto-saves (debounced), so this is an
// explicit "write now + confirm" control with a live Saved / Unsaved state, so
// it's clear whether your edits are persisted. Dirty state is plan-wide (the
// underlying save is), so every goal's button reflects the same signal; a
// beforeunload guard (in plan_storage) warns if you leave while unsaved.
export default class extends Controller {
  static targets = ["label"]

  connect() {
    this._unsub = onDirtyChange((d) => this._render(d))
    this._render(isDirty())
  }

  disconnect() { this._unsub?.(); clearTimeout(this._t) }

  save(event) {
    event.preventDefault()
    flushAll() // run every pending save synchronously → isDirty() clears
    this._flash()
  }

  _render(dirty) {
    this.element.classList.toggle("is-dirty", dirty)
    this.element.classList.toggle("is-clean", !dirty)
    if (this.hasLabelTarget) this.labelTarget.textContent = dirty ? "Save" : "Saved"
    this.element.setAttribute("title", dirty ? "Unsaved changes — click to save now" : "All changes saved")
  }

  _flash() {
    this.element.classList.remove("is-dirty")
    this.element.classList.add("is-clean")
    if (this.hasLabelTarget) this.labelTarget.textContent = "Saved ✓"
    clearTimeout(this._t)
    this._t = setTimeout(() => this._render(isDirty()), 1400)
  }
}
